import { createContext, useState, useEffect } from "react";

const NominaContext = createContext({});

export const NominaProvider = ({ children }) => {
  const [selectedNomina, setSelectedNomina] = useState(() => {
  const saved = localStorage.getItem("selectedNomina");
  if (!saved) return null;

  try {
    return JSON.parse(saved);
  } catch (e) {
    console.warn("selectedNomina corrupto en localStorage, se resetea", e);
    localStorage.removeItem("selectedNomina");
    return null;
  }
});

  useEffect(() => {
    if (selectedNomina !== null) {
      localStorage.setItem("selectedNomina", JSON.stringify(selectedNomina));
    } else {
      localStorage.removeItem("selectedNomina");
    }
  }, [selectedNomina]);

  return (
    <NominaContext.Provider value={{ selectedNomina, setSelectedNomina }}>
      {children}
    </NominaContext.Provider>
  );
};

export default NominaContext;
